import { useEffect } from "react";

const GoogleTranslate = () => {
    useEffect(() => {
        if (!document.querySelector("script[src='//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit']")) {
            const addScript = document.createElement("script");
            addScript.src = "//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
            addScript.async = true;
            document.body.appendChild(addScript);
        }

        window.googleTranslateElementInit = () => {
            new window.google.translate.TranslateElement(
                { pageLanguage: "en",
                    autoDisplay: false, // Prevents automatic display of the translation banner
                 },
                "google_translate_element"
            );
        };
    }, []);

    return <div id="google_translate_element"></div>;
};

export default GoogleTranslate;